import React from "react";
import { useCommonFormStyles } from "./common";
import { RenderProperty } from "@/src/views/RenderProperty";
export function FormRichText(props) {
    var commonFormStyles = useCommonFormStyles();
    return (React.createElement("div", { className: commonFormStyles.singleCol },
        React.createElement(RenderProperty, { value: props.data.paragraphText })));
}
